<template>
	<div class="app-container">
		<el-form v-model="form" :inline="true" ref="filtrateForm" size="mini">
			<el-form-item label="订单ID:" style="float:left;">
				<el-select
					v-model="order_out_type"
					size="mini"
					@change="selectOrderType"
				>
					<el-option label="外部订单号" value="1"></el-option>
					<el-option label="内部订单号" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="float:left;">
				<el-input
					size="mini"
					v-if="order_out_type == 1"
					v-model="form.out_order_no_like"
					style="width:160px;"
					placeholder="输入订单号搜索"
				>
				</el-input>
				<el-input
					size="mini"
					v-if="order_out_type == 2"
					v-model="form.order_no_like"
					style="width:160px;"
					placeholder="输入订单号搜索"
				></el-input>
				<el-input
					size="mini"
					v-if="order_out_type != 2 && order_out_type != 1"
					placeholder="输入订单号搜索"
					style="width:160px;"
				></el-input>
			</el-form-item>

			<el-form-item label="来源:" style="float:left;">
				<el-autocomplete
					popper-class="my-autocomplete"
					v-model="AutoVal"
					:fetch-suggestions="querySearch"
					placeholder="请输入内容"
					@select="handleSelect"
				>
					<template slot-scope="{ item }">
						<div class="name">{{ item.name }}</div>
					</template>
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="供应商：">
				<el-autocomplete
					popper-class="my-autocomplete"
					v-model="supplierName"
					:fetch-suggestions="querySearch1"
					placeholder="请输入内容"
					@select="handleSelect1"
				>
					<template slot-scope="{ item }">
						<div class="name">{{ item.supplier_name }}</div>
					</template>
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="对接方式:" style="float:left;">
				<el-select v-model="form.supply_channel_type">
					<el-option label="全部" value></el-option>
					<el-option label="1688接入" value="1"></el-option>
					<el-option label="供应商接入" value="2"></el-option>
					<el-option label="自营创建" value="0"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="订单时间:" style="float:left;">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="selectedTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="发货时间:" style="float:left;">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="deliveryTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="签收时间:" style="float:left;">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="signTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="商品名称:" style="float:left;">
				<el-input
					size="mini"
					placeholder="请输入商品名称搜索"
					style="width:180px;"
					v-model="form.title_like"
				></el-input>
			</el-form-item>
			<el-form-item label="负责人：">
				<el-input
					style="width:180px;"
					v-model="form.charge_name"
					placeholder="输入负责人姓名"
				/>
			</el-form-item>
			<el-form-item label="订单状态:" style="float:left;">
				<el-select style="width:180px;" v-model="form.order_status">
					<el-option label="全部" value></el-option>
					<el-option
						v-for="(item, index) in order_status_list"
						:key="index"
						:label="item.name"
						:value="item.status"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="1688订单号：">
				<el-input
					style="width:180px;"
					v-model="form.alibaba_order_id"
					placeholder="输入1688订单号"
				/>
			</el-form-item>
			<el-form-item label="收件人手机号：">
				<el-input
					style="width:180px;"
					v-model="form.buyer_phone"
					placeholder="输入收件人手机号"
				/>
			</el-form-item>
			<el-form-item style="float:left;">
				<el-button type="primary" @click="pageChange(1)">查询</el-button>
				<el-button @click="resetForm('filtrateForm')">重置</el-button>
				<el-button type="warning" @click="exportOrderData">导出</el-button>
			</el-form-item>
			<el-form-item style="float:left;">
				<el-upload
					class="upload-demo"
					:action="action"
					:headers="headers"
					:multiple="false"
					:limit="1"
					:file-list="fileList"
					:show-file-list="false"
					:on-exceed="handleExceed"
					:on-success="handleSuccess"
					:on-error="handleSuccess"
					:on-progress="handleProgress"
					:before-upload="handleChoose"
				>
					<el-button type="primary">点击上传</el-button>
				</el-upload>
			</el-form-item>
		</el-form>

		<el-table
			:data="tableData"
			max-height="600"
			size="mini"
			style="width: 100%"
			:cell-style="tc"
			:header-cell-style="tccolor"
			ref="table"
			@sort-change="sortChange"
			v-loading="loading"
		>
			<el-table-column
				label="订单ID"
				prop="order_no"
				width="160"
			></el-table-column>
			<el-table-column
				label="渠道订单ID"
				prop="out_order_no"
				width="140"
			></el-table-column>
			<el-table-column
				label="1688订单号"
				prop="alibaba_order_id"
				width="160"
			></el-table-column>
			<el-table-column label="是否结算" prop="is_settlement_name">
			</el-table-column>
			<el-table-column label="来源">
				<template slot-scope="scope">
					<p v-if="scope.row.supplier_channel">
						{{ scope.row.supplier_channel.name }}
					</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="供应商" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_name">
						{{ scope.row.supplier_name }}
					</div>
					<div v-else>--</div>
				</template>
			</el-table-column>
			<el-table-column label="对接方式">
				<template slot-scope="scope">
					<div v-if="scope.row.supplier_channel">
						<p v-if="scope.row.supplier_channel.type == 0">自营创建</p>
						<p v-if="scope.row.supplier_channel.type == 1">1688接入</p>
						<p v-if="scope.row.supplier_channel.type == 2">供应商接入</p>
					</div>
					<div v-else>---</div>
				</template>
			</el-table-column>
			<el-table-column label="商品图">
				<template slot-scope="scope">
					<img style="width:36px;height:36px;" :src="scope.row.img_url" />
				</template>
			</el-table-column>
			<el-table-column
				label="商品名称"
				prop="title"
				width="210"
			></el-table-column>
			<el-table-column
				label="采购价"
				prop="purchase_price_money"
			></el-table-column>
			<el-table-column label="商品分类">
				<template slot-scope="scope">
					<div v-if="scope.row.order_product">
						<p v-for="item in scope.row.order_product" :key="item.order_id">
							<span v-if="item.product_cate">{{ item.product_cate.name }}</span>
							<span v-else>---</span>
						</p>
					</div>
					<div v-else>---</div>
				</template>
			</el-table-column>
			<el-table-column label="税收分类" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.goods_class">{{ scope.row.goods_class }}</div>
					<div v-else>--</div>
				</template>
			</el-table-column>

			<el-table-column label="订单状态">
				<template slot-scope="scope">
					<p v-if="scope.row.order_status == 0">
						<span class="account_status_zhifu">●</span>待支付
					</p>
					<p v-if="scope.row.order_status == 1">
						<span class="account_status_fahuo">●</span>待发货
					</p>
					<p v-if="scope.row.order_status == 2">
						<span class="account_status_fahuo">●</span>已发货
					</p>
					<p v-if="scope.row.order_status == 6">
						<span class="account_status_shouhuo">●</span>已签收
					</p>
					<p v-if="scope.row.order_status == 7">
						<span class="account_status_shouhuo">●</span>已收货
					</p>
					<p v-if="scope.row.order_status == 3">
						<span class="account_status_wancheng">●</span>已取消
					</p>
					<p v-if="scope.row.order_status == 4">
						<span class="account_status_wancheng">●</span>已完成
					</p>
					<p v-if="scope.row.order_status == 5">
						<span class="account_status_guanbi">●</span>已关闭
					</p>
				</template>
			</el-table-column>
			<el-table-column label="维权状态">
				<template slot-scope="scope">
					<p v-if="scope.row.after_sale_status == 0">无</p>
					<p v-if="scope.row.after_sale_status == 1">待审核</p>
					<p v-if="scope.row.after_sale_status == 2">处理中</p>
					<p v-if="scope.row.after_sale_status == 3">处理完成</p>
					<p v-if="scope.row.after_sale_status == 4">已拒绝</p>
				</template>
			</el-table-column>
			<el-table-column label="购买件数" sortable="quantity" width="120">
				<template slot-scope="scope">
					<p v-if="scope.row.quantity">{{ scope.row.quantity }}件</p>
					<p v-else>---</p>
				</template>
			</el-table-column>
			<el-table-column label="实付金额">
				<template slot-scope="scope">
					<div v-if="scope.row.order_pay">
						<p v-if="scope.row.order_pay.money_pay">
							¥ {{ scope.row.order_pay.money_pay }}
						</p>
						<p v-else>---</p>
					</div>
					<div v-else>---</div>
				</template>
			</el-table-column>
			<el-table-column
				label="创建时间"
				prop="created_at"
				sortable="created_at"
				width="140"
			></el-table-column>
			<el-table-column
				label="发货时间"
				prop="express_send_time"
				sortable="express_send_time"
				width="140"
			></el-table-column>
			<el-table-column
				label="签收时间"
				prop="sign_time_info"
				sortable="sign_time_info"
				width="140"
			></el-table-column>
			<!-- <el-table-column
				label="结算时间"
				prop="settlement_time"
				width="140"
			></el-table-column>
			<el-table-column label="结算人" prop="settlement_name"></el-table-column> -->
			<el-table-column label="操作" fixed="right" width="160">
				<template slot-scope="scope">
					<el-button
						type="warning"
						size="mini"
						@click="gotoOrderDetail(scope.row.id)"
						>详情</el-button
					>
					<el-button
						type="danger"
						size="mini"
						@click="watchOrderDialog(scope.row.id)"
						>日志</el-button
					>
				</template>
			</el-table-column>
			<el-table-column
				label="关闭时间"
				prop="close_time"
				width="160"
			></el-table-column>
			<el-table-column
				label="签约主体"
				prop="partner_name"
				width="160"
			></el-table-column>
			<el-table-column label="开票状态" prop="is_invoice"></el-table-column>
		</el-table>
		<div class="info">订单数：{{ total }}， 总购买数：{{ quantity_num }}</div>

		<div class="pagination">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="pageChange"
				:current-page="form.page"
				:page-sizes="[20, 50, 100]"
				:page-size="form.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>

		<gydialog title="订单日志" :visible.sync="showOrderDialog" width="640px">
			<div style="padding:20px 12px;">
				<el-table
					border
					:data="orderTableData"
					style="width: 100%"
					max-height="600"
					:cell-style="tc"
					:header-cell-style="tccolor"
					v-loading="loading"
				>
					<el-table-column label="更新时间" prop="created_at"></el-table-column>
					<el-table-column label="订单状态">
						<template slot-scope="scope">
							<p v-if="scope.row.order_status == 0">
								待支付
							</p>
							<p v-if="scope.row.order_status == 1">
								待发货
							</p>
							<p v-if="scope.row.order_status == 2">
								已发货
							</p>

							<p v-if="scope.row.order_status == 7">
								已收货
							</p>
							<p v-if="scope.row.order_status == 6">
								已签收
							</p>

							<p v-if="scope.row.order_status == 3">
								已取消
							</p>
							<p v-if="scope.row.order_status == 4">
								已完成
							</p>
							<p v-if="scope.row.order_status == 5">
								已关闭
							</p>
						</template>
					</el-table-column>

					<el-table-column label="日志备注" prop="log"></el-table-column>
				</el-table>

				<!-- <div class="pagination">
					<el-pagination
						background
						@current-change="remarkpageChange"
						:current-page="remarkform.page"
						:page-size="remarkform.size"
						layout="total,  prev, pager, next, jumper"
						:total="orderTotal"
					>
					</el-pagination>
				</div> -->
			</div>
		</gydialog>
	</div>
</template>
<script>
import { supplyChannel, getSuppliers } from '@/api/goods'
import { GyOrderList, exportOrderList, orderLogList } from '@/api/order'
import { parseTime } from '@/utils/index'
import { BASE_API } from '@/config'
import store from '@/store/index'
export default {
	data() {
		return {
			action: `${BASE_API}/admin/order/import`,
			headers: {
				token: store.getters.token
			},
			fileList: [],
			loading: false,
			order_out_type: '',
			form: {
				page: 1,
				page_size: 20,
				order_no_like: '',
				out_order_no_like: '',
				supply_id: '',
				supply_channel_type: '',
				created_at_gt: '',
				created_at_lt: '',
				express_send_time_gt: '',
				express_send_time_lt: '',
				sign_time_start: '',
				sign_time_end: '',
				title_like: '',
				orderBys: '',
				order_status: '',
				filename: '',
				charge_name: '',
				alibaba_order_id: '',
				supplier_id: '',
				buyer_phone: ''
			},
			AutoVal: '',
			supplierName: '',
			selectedTime: '',
			deliveryTime: '',
			signTime: '',
			timeOptions: {
				shortcuts: [
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近15天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(new Date().setMonth(new Date().getMonth() - 1))
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			//来源数据
			sourceList: [],
			//供应商数据
			supplierList: [],
			tableData: [],
			total: 0,
			quantity_num: 0,
			order_status_list: [
				{ status: 0, name: '待支付' },
				{ status: 1, name: '待发货' },
				{ status: 2, name: '已发货' },
				{ status: 3, name: '已取消' },
				{ status: 4, name: '已完成' },
				{ status: 5, name: '已关闭' },
				{ status: 6, name: '已签收' },
				{ status: 7, name: '已收货' }
			],
			//日志
			showOrderDialog: false,
			currentId: '',
			orderTableData: [],
			orderTotal: 0,
			remarkform: {
				page: 1,
				size: 20
			}
		}
	},

	activated() {
		this.supplyChannelListData()
		this.getSuppliersFn()
	},
	methods: {
		querySearch(queryString, cb) {
			var restaurants = this.sourceList
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			console.log(results)
			cb(results)
		},
		createFilter(queryString) {
			return sourceList => {
				return (
					sourceList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect(item) {
			console.log(item)
			this.form.supply_id = item.id
			this.AutoVal = item.name
		},
		querySearch1(queryString, cb) {
			var restaurants = this.supplierList
			console.log(restaurants)
			var results = queryString
				? restaurants.filter(this.createFilter1(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter1(queryString) {
			console.log(queryString)
			return supplierList => {
				return (
					supplierList.supplier_name
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect1(item) {
			console.log(item)
			this.form.supplier_id = item.id
			this.supplierName = item.supplier_name
		},
		handleSuccess(response, file, fileList) {
			console.log(response, file, fileList, 11)
			this.$message.warning(response.msg)
			this.loading = false
			this.fileList = []
		},
		handleProgress(file) {
			console.log(file, 22)
			// this.loading = true
		},
		handleExceed(files, fileList) {
			console.log(files, fileList)
			this.$message.warning(
				`当前限制选择 1个文件，本次选择了 ${
					files.length
				} 个文件，共选择了 ${files.length + fileList.length} 个文件`
			)
		},
		handleChoose(file) {
			console.log(file, 33)
			this.loading = true
		},
		pageChange(page) {
			this.form.page = page
			this.getList()
		},
		selectOrderType(id) {
			if (id == 1) {
				this.form.order_no = ''
			} else {
				this.form.out_order_no = ''
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.selectedTime = ''
			this.deliveryTime = ''
			this.signTime = ''
			this.order_out_type = ''
			this.form = {
				order_no_like: '',
				out_order_no_like: '',
				supply_id: '',
				supply_channel_type: '',
				created_at_gt: '',
				created_at_lt: '',
				express_send_time_gt: '',
				express_send_time_lt: '',
				sign_time_start: '',
				sign_time_end: '',
				title_like: '',
				charge_name: '',
				page: this.form.page,
				page_size: this.form.page_size,
				orderBys: '',
				alibaba_order_id: '',
				buyer_phone: ''
			}
		},
		//查看详情
		gotoOrderDetail(id) {
			this.$router.push({
				path: './detail',
				query: {
					orderId: id
				}
			})
		},

		//操作日志
		watchOrderDialog(id) {
			this.currentId = id
			this.orderRemarkListData()
		},
		handleSizeChange(val) {
			this.form.size = val
			this.pageChange(1)
		},
		sortChange(e) {
			if (e.order) {
				if (e.order == 'ascending') {
					this.form.orderBys = e.column.sortable
				} else {
					this.form.orderBys = '-' + e.column.sortChange
				}
			}
			this.pageChange(1)
		},
		remarkpageChange(page) {
			this.remarkform.page = page
			this.orderRemarkListData()
		},
		async getList() {
			const form = this.form
			if (this.selectedTime !== '') {
				form.created_at_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.created_at_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.deliveryTime !== '') {
				form.express_send_time_gt = parseTime(
					this.deliveryTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.express_send_time_lt = parseTime(
					this.deliveryTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.signTime !== '') {
				form.sign_time_start = parseTime(
					this.signTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.sign_time_end = parseTime(this.signTime[1], 'yyyy-MM-dd hh:mm:ss')
			}
			let res = await GyOrderList(this.form)
			let list = this.supplierList
			for (let i = 0; i < list.length; i++) {
				for (let j = 0; j < res.data.length; j++) {
					if (res.data[j].supplier_id == list[i].id) {
						res.data[j].supplier_name = list[i].supplier_name
					}
				}
			}
			this.tableData = res.data
			this.total = res.total
			this.quantity_num = res.quantity_num
		},

		async exportOrderData() {
			if (this.selectedTime !== '') {
				this.form.created_at_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.created_at_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.deliveryTime !== '') {
				this.form.express_send_time_gt = parseTime(
					this.deliveryTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.express_send_time_lt = parseTime(
					this.deliveryTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			if (this.signTime !== '') {
				this.form.sign_time_start = parseTime(
					this.signTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				this.form.sign_time_end = parseTime(
					this.signTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			let res = await exportOrderList(this.form)
			if (res.code === 2) {
				this.loading = true
				console.log(res)
				this.form.page = res.page
				this.form.filename = res.filename
				this.form.last_id = res.last_id
				this.exportOrderData()
			} else if (res.code === 1) {
				this.loading = false
				window.open(`${BASE_API}/admin/download/zip/${res.download_token}`)
			} else {
				this.loading = false
				this.$message.error(res.message)
			}
		},
		//获取商品来源
		async supplyChannelListData() {
			let res = await supplyChannel({ name: '', page: 1, size: 1000 })
			this.sourceList = res.data
		},
		//获取供应商来源
		async getSuppliersFn() {
			try {
				let res = await getSuppliers({
					name: '',
					page: 1,
					size: 1000
				})
				this.supplierList = res
				this.getList()
			} catch (e) {
				console.log(e)
			}
		},
		//订单备注
		async orderRemarkListData() {
			let res = await orderLogList({ id: this.currentId })
			this.showOrderDialog = true
			this.orderTableData = res
			// this.orderTotal = res.total
		},
		tc() {
			return 'text-align:center;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	}
}
</script>
<style lang="scss" scoped>
.el-form {
	display: flex;
	flex-wrap: wrap;
}
.app-container {
	padding: 20px;
	background-color: #fff;
}
//已完成
.account_status_wancheng {
	color: #67c23a;
}
//已关闭
.account_status_guanbi {
	color: #f4222d;
}
//待支付
.account_status_zhifu {
	color: rgb(191, 191, 191);
}
//待发货
.account_status_fahuo {
	color: rgb(253, 190, 44);
}
//待收获
.account_status_shouhuo {
	color: rgb(26, 121, 206);
}
.pagination {
	float: right;
	margin-top: 20px;
}
.info {
	text-align: left;
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0;
}
</style>
